import type { IntlShape } from 'react-intl'
import type { TripDay, TripStop } from 'tripPlanner/api/types'
import { formatStopDateRange } from 'tripPlanner/utils/chatDates'
import {
  getStopDurationLabel,
  resolveStopDuration,
  type StopDuration,
} from 'tripPlanner/utils/stopDuration'

export {
  getStopDurationDayCount,
  formatStopDurationLabel,
  getStopDurationLabel,
  isIsoDate,
} from 'tripPlanner/utils/stopDuration'
export type { StopDuration } from 'tripPlanner/utils/stopDuration'

export function getSortedStopDays(stop: TripStop): Array<TripDay> {
  return [...(stop.days ?? [])].sort((a, b) => a.dayNumber - b.dayNumber)
}

export function getExistingStopDuration(stop: TripStop): StopDuration | undefined {
  return resolveStopDuration(stop)
}

export function getExistingStopDurationDayCount(stop: TripStop): number | undefined {
  return getExistingStopDuration(stop)?.dayCount
}

/** Planned day rows that would be deleted when shrinking a stop to `durationDayCount`. */
export function countPlannedDaysBeyondDuration(
  days: Array<Pick<TripDay, 'dayNumber'>> | undefined,
  durationDayCount: number,
): number {
  return (days ?? []).filter(day => day.dayNumber > durationDayCount).length
}

export function getStopDateRangeLabel(stop: TripStop): string | undefined {
  if (!stop.startDate || !stop.endDate) return undefined
  return formatStopDateRange(stop.startDate, stop.endDate)
}

export function getStopTimingSubtitle(intl: IntlShape, stop: TripStop): string | undefined {
  const parts = [
    getStopDurationLabel(intl, stop),
    getStopDateRangeLabel(stop),
  ].filter(Boolean)

  return parts.length > 0 ? parts.join(' · ') : undefined
}
